module.exports = (__webpack_require__(9))(867);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/avatar/index.js from dll-reference antd_library
// module id = 249
// module chunks = 42